import { useQuery } from '@tanstack/react-query';
import Administrator from '../models/administrator';
import useRestService from '../shared/rest-service';

export function useAdministrators() {
  const { fetchWrapper } = useRestService();

  return useQuery<Administrator[], Error>(['administrators'], () => {
    return fetchWrapper('api/management/administrators');
  });
}
